import React, { useState, useEffect, useRef } from 'react'
import MapboxGL from 'mapbox-gl';
import { BuildingModelType } from '../interface-type'
import { createModelLayer } from './use-func/model3d'
import DarkTheme from '../map-styles/dark'
import LightTheme from '../map-styles/default'
import DarkVekinTheme from '../map-styles/dark-vekin'

const BuildingModel: React.FunctionComponent<BuildingModelType> = (props) => {
    const ref = useRef<any>(null)
    const [map, setmap] = useState<MapboxGL.Map | undefined>(undefined)
    const { buildings, selectBuilding, selectedColor, theme, onClickBuilding, onMapUpdate, ...mapOptions } = props

    useEffect(() => {
        const renderMap = new MapboxGL.Map({
            container: ref.current,
            style: theme === 'dark' ? DarkTheme : theme === 'dark-vekin' ? DarkVekinTheme : LightTheme,
            antialias: true,
            ...mapOptions
        })
        renderMap.on('load', () => {
            if (buildings) {
                const model3dLayer = createModelLayer(buildings)
                renderMap.addLayer(model3dLayer)
            }
            setmap(renderMap)
        })
        return () => {
            renderMap.remove()
            setmap(undefined)
        };
    }, [])

    useEffect(() => {
        onMapUpdate(map)
    }, [map])

    useEffect(() => {
        if (map && buildings) {
            const backupModel = map.getLayer(buildings.id)
            map.setStyle(props.theme === 'dark' ? DarkTheme : props.theme === 'dark-vekin' ? DarkVekinTheme : LightTheme)
            const hasModel = map.getLayer(buildings.id)
            if (!hasModel) {
                map.addLayer(backupModel)
            }
        }
    }, [theme, map, buildings])
    return (
        <div ref={ref} style={{ height: "100%", width: "100%" }} />
    )
}

BuildingModel.defaultProps = {
    onMapUpdate: () => { }
}

export default BuildingModel
